import React, { useEffect, useState, useContext } from "react";

import UsersApi from "../../../Classes/API/UsersApi";
import AccountingApi from "../../../Classes/API/AccountingApi";

import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import SearchAccountingEntriesReq from "../../../Classes/Models/Requests/Accounting/SearchAccountingEntriesReq";
import SearchUserModel from "../../../Classes/Models/Requests/Users/SearchUser";
import SearchAccountingSessions from "../../../Classes/Models/Requests/Accounting/SearchAccountingSession";
import SearchAccountingTherapistHourId from "../../../Classes/Models/Requests/Accounting/SearchAccountingTherapistHourId";
import MDBox from "components/MDBox";
import QuickDate from "../../../components/QuickDate";
import AsyncSelect from "react-select/async";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import { useLocation, NavLink } from "react-router-dom";
import DateTimePicker from "react-datetime-picker";
import { LanguageContext } from "App";
import Swal from "sweetalert2";
import { use } from "react";
const SearchEntries = ({ GetEntries, setSearchRequest }) => {
  const [PatientsSearch, SetPatientSearch] = useState("");
  const [TherapistsSearch, SetTherapistSearch] = useState("");
  const [AccountingTherapistHourSearch, SetAccountingTherapistHourSearch] = useState("");
  const [AccountingSessionsSearch, SetAccouningSessionsSearch] = useState("");
  const [IdSearch, SetIdSearch] = useState("");

  const [Id, SetId] = useState("");
  const { translations } = useContext(LanguageContext);
  const [title, SetTitle] = useState("");
  const [fromAmount, SetFromAmount] = useState();
  const [toAmount, SetToAmount] = useState();
  const [fromDate, SetFromDate] = useState("");
  const [toDate, SetToDate] = useState("");
  const [description, SetDescription] = useState("");
  const [category, SetCategory] = useState("");
  const [entryType, SetEntryType] = useState("");
  const [isProfit, SetisProfit] = useState();
  const [patient, Setpatient] = useState({});
  const [accountingSessionId, SetaccountingSessionId] = useState();
  const [therapistId, SettherapistId] = useState();
  const [accountingTherapistHourId, SetaccountingTherapistHourId] = useState();
  const [IsLoaded, setIsLoaded] = useState(false);

  const [OptionId, SetOptionId] = useState([]);
  const [OptionUserid, SetOptionUserid] = useState([]);
  const [OptionSessionid, SetOptionSessionid] = useState([]);
  const [OptionTherapistid, SetOptionTherapistid] = useState([]);
  const [OptionHourid, SetOptionHourid] = useState([]);

  useEffect(() => {
    GetAccountingTherapistHours().then((res) => {
      SetOptionHourid(res);
    });
  }, []);

  useEffect(() => {
    GetTherapists().then((res) => {
      SetOptionTherapistid(res);
    });
  }, []);

  useEffect(() => {
    GetAccountingSessions().then((res) => {
      SetOptionSessionid(res);
    });
  }, []);

  useEffect(() => {
    GetPatients().then((res) => {
      SetOptionUserid(res);
    });
  }, []);

  useEffect(() => {
    GetAccountingEntryIds().then((res) => {
      SetOptionId(res);
    });
  }, []);
  const GetAccountingEntryIds = async () => {
    let tempReq = new SearchAccountingEntriesReq();

    tempReq.id = IdSearch;

    let res = await AccountingApi.SearchAccountingEntries(tempReq);
    console.log(res);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({
          value: item.id,
          label: "ID: " + item.id + "  Desc: " + item.description,
        });
      });

      return optionsArr;
    }
  };

  const GetAccountingSessions = async () => {
    let accountingSessionReqs = new SearchAccountingSessions();

    accountingSessionReqs.id = AccountingSessionsSearch;

    let res = await SessionsApi.SearchAccountingSessions(accountingSessionReqs);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.id, label: "ID: " + item.id });
      });

      return optionsArr;
    }
  };

  const GetPatients = async () => {
    let usersReq = new SearchUserModel();
    usersReq.userType = "Patient";
    usersReq.name = PatientsSearch;
    let res = await UsersApi.SearchUsers(usersReq);
    console.log("userID ", res);
    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item, label: item.name });
      });

      return optionsArr;
    }
  };

  const GetTherapists = async () => {
    let usersReq = new SearchUserModel();
    usersReq.userType = "Therapist";
    usersReq.name = TherapistsSearch;

    let res = await UsersApi.SearchUsers(usersReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.getTherapist.id, label: item.name });
      });

      return optionsArr;
    }
  };

  const GetAccountingTherapistHours = async () => {
    let accountingTherapistHourReq = new SearchAccountingTherapistHourId();
    accountingTherapistHourReq.userType = AccountingTherapistHourSearch;

    let res = await AccountingApi.accountingTherapistHourId(accountingTherapistHourReq);
    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.id, label: "ID: " + item.id });
      });

      return optionsArr;
    }
  };

  async function ExportExcel() {
    let model = new SearchAccountingEntriesReq();

    model.id = Id;
    model.title = title;
    model.accountingSessionId = accountingSessionId;
    model.accountingTherapistHourId = accountingTherapistHourId;
    model.category = category;
    model.description = description;
    model.fromAmount = fromAmount;
    model.toAmount = toAmount;
    // model.employeeId = employeeId
    model.entryType = entryType;
    // model.facilityId = facilityId
    model.isProfit = isProfit;
    model.therapistId = therapistId;
    model.userId = patient.id;

    console.log(model);
    var res = await AccountingApi.ExportEntriesToExcel(model);
    console.log(res);
    var csvURL = window.URL.createObjectURL(res);
    let tempLink = document.createElement("a");
    tempLink.href = csvURL;
    tempLink.setAttribute("download", "SearchEntriesResult.xlsx");
    tempLink.click();
  }

  async function ExportExcelWithDates() {
    Swal.fire({
      icon: "info",
      title: "Generating Excel Report",
      text: "Please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let model = new SearchAccountingEntriesReq();

    model.id = Id;
    model.title = title;
    model.accountingSessionId = accountingSessionId;
    model.accountingTherapistHourId = accountingTherapistHourId;
    model.category = category;
    model.description = description;
    model.fromAmount = fromAmount;
    model.toAmount = toAmount;
    model.entryType = entryType;
    model.isProfit = isProfit;
    model.therapistId = therapistId;
    model.userId = patient.id;
    model.fromDate = fromDate;
    model.toDate = toDate;

    if (fromDate) {
      model.fromDate = fromDate + "T00:00:00";
    }
    if (toDate) {
      model.toDate = toDate + "T23:59:59";
    }

    console.log(model);
    var res = await AccountingApi.ExportEntriesToExcel(model);
    console.log(res);
    var csvURL = window.URL.createObjectURL(res);
    let tempLink = document.createElement("a");
    tempLink.href = csvURL;
    tempLink.setAttribute("download", "SearchEntriesResult.xlsx");
    tempLink.click();

    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Excel Report Generated",
      showConfirmButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.hideLoading();
      },
    });
  }

  async function submitFormNoDate() {
    let model = new SearchAccountingEntriesReq();

    model.id = Id;
    model.title = title;
    model.accountingSessionId = accountingSessionId;
    model.accountingTherapistHourId = accountingTherapistHourId;
    model.category = category;
    model.description = description;
    model.fromAmount = fromAmount;
    model.toAmount = toAmount;
    // model.employeeId = employeeId
    model.entryType = entryType;
    // model.facilityId = facilityId
    model.isProfit = isProfit;
    model.therapistId = therapistId;
    model.userId = patient.id;

    setSearchRequest(model);

    console.log(model);
    GetEntries(model);
    // var res = await AccountingApi.SearchAccountingEntries(model);

    // console.log(res)
    // if (res.status == "Success") {
    //   setEntries(res.data)
    // }
  }

  async function submitForm() {
    let model = new SearchAccountingEntriesReq();

    model.id = Id;
    model.title = title;
    model.accountingSessionId = accountingSessionId;
    model.accountingTherapistHourId = accountingTherapistHourId;
    model.category = category;
    model.description = description;
    model.fromAmount = fromAmount;
    model.toAmount = toAmount;
    model.fromDate = fromDate;
    model.toDate = toDate;
    // model.employeeId = employeeId
    model.entryType = entryType;
    // model.facilityId = facilityId
    model.isProfit = isProfit;
    model.therapistId = therapistId;
    model.userId = patient.id;
    if (fromDate) {
      model.fromDate = fromDate + "T00:00:00";
    }
    if (toDate) {
      model.toDate = toDate + "T23:59:59";
    }

    console.log(model);
    setSearchRequest(model);

    // try {
    //   // await GetEntries(model);
    //   // Assuming GetEntries handles the data fetching
    // } catch (error) {
    //   console.error("Error fetching entries:", error);
    //   Swal.fire({
    //     icon: "error",
    //     title: "Error",
    //     text: "Failed to load entries",
    //   });
    // } finally {
    //   Swal.close(); // Close the Swal after data is retrieved or an error occurs
    // }
  }

  return (
    <>
      <div className="card">
        <MDBox
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className="mb-3"
        >
          <MDButton
            component={NavLink}
            to="/CreateNewAccountingEntry"
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="success"
          >
            {/* /AccountingEntries/CreateNewEntry */}
            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
            &nbsp;{translations.SearchEnteryAddNewAccountingEntry}
          </MDButton>
        </MDBox>
        <div className="container-fluid">
          <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
            <div className="row">
              <div className="col-md-4 mt-2">
                {/* patientId */}
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.SearchEnteryEntryId}
                  loadOptions={GetAccountingEntryIds}
                  onInputChange={SetIdSearch}
                  defaultOptions={OptionId}
                  onChange={(e) => SetId(e ? e.value : "")}
                />
              </div>

              <div className="col-md-4 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={translations.CreateAccountingEntrypgtitle}
                  aria-describedby="sizing-addon1"
                  onChange={(e) => SetTitle(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={translations.SearchEnteryFromAmount}
                  aria-describedby="sizing-addon1"
                  onChange={(e) => SetFromAmount(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={translations.SearchEnteryToAmount}
                  aria-describedby="sizing-addon1"
                  onChange={(e) => SetToAmount(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={translations.SearchEnterydescription}
                  aria-describedby="sizing-addon1"
                  onChange={(e) => SetDescription(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={translations.SearchEnterycategory}
                  aria-describedby="sizing-addon1"
                  onChange={(e) => SetCategory(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={translations.SearchEnteryEntryType}
                  aria-describedby="sizing-addon1"
                  onChange={(e) => SetEntryType(e.target.value)}
                />
              </div>

              <div className="col-md-4 mt-2">
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.SearchEnteryUserId}
                  defaultOptions={OptionUserid}
                  loadOptions={GetPatients}
                  onInputChange={SetPatientSearch}
                  onChange={(e) => Setpatient(e ? e.value : "")}
                />
              </div>

              <div className="col-md-4 mt-2">
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.SearchEnteryAccountingSessionId}
                  defaultOptions={OptionSessionid}
                  loadOptions={GetAccountingSessions}
                  onInputChange={SetAccouningSessionsSearch}
                  onChange={(e) => SetaccountingSessionId(e ? e.value : "")}
                />
              </div>

              <div className="col-md-4 mt-2">
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.SearchEnteryTherapistId}
                  defaultOptions={OptionTherapistid}
                  loadOptions={GetTherapists}
                  onInputChange={SetTherapistSearch}
                  onChange={(e) => {
                    console.log({ e });
                    SettherapistId(e ? e.value : "");
                  }}
                />
              </div>

              <div className="col-md-4 mt-2">
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.SearchEnteryAccountingTherapistHourId}
                  defaultOptions={OptionHourid}
                  loadOptions={GetAccountingTherapistHours}
                  onInputChange={SetAccountingTherapistHourSearch}
                  onChange={(e) => SetaccountingTherapistHourId(e ? e.value : "null")}
                />
              </div>
              <div className="col-md-4 mt-2">
                {/* isProfit */}
                <label className="pt-4 mr-3">{translations.SearchEnteryIsProfit}</label>
                <input
                  type="checkbox"
                  aria-label="Checkbox for following text input"
                  onChange={(e) => SetisProfit(e.target.checked)}
                />
              </div>

              <div className="qd col-md-5">
                <div className="quick_date_container">
                  <p>{translations.PatientStayQuickDate}</p>
                  <QuickDate
                    setFrom={SetFromDate}
                    setTo={SetToDate}
                    placeholder={"Quick Last Updated"}
                  />
                </div>
              </div>
              <div className="qd col-md-6">
                <label>{translations.PatientStayStartDateFrom}:</label>
                <div
                  className="quick_date"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto auto auto", // 3 columns for the input, p, and second input
                    gap: "10px", // optional, for spacing between the columns
                    alignItems: "center", // vertically center the items
                  }}
                >
                  <input
                    type="date"
                    style={{
                      width: "auto",
                      ...(window.innerWidth <= 768 && { width: "100%" }),
                    }}
                    onChange={(e) => {
                      SetFromDate(e.target.value);
                    }}
                    value={fromDate}
                  />

                  <p>{translations.PatientStayTo}</p>

                  <input
                    type="date"
                    style={{
                      width: "auto",
                      ...(window.innerWidth <= 768 && { width: "100%" }),
                    }}
                    onChange={(e) => {
                      SetToDate(e.target.value);
                    }}
                    value={toDate}
                  />
                </div>
              </div>

              <div className="col-md-12 text-right">
                <MDButton
                  type="button"
                  sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                  color="text"
                  onClick={submitForm}
                >
                  {translations.createAccountsessionSingleSessionSearchSearch}
                </MDButton>
                {/* <button type="button" className='ml-2 mr-2 btn btn-success mt-2 float-right' onClick={ExportExcel}>{translations.SearchEnteryExportSearchtoExcel}</button> */}
                <MDButton
                  type="button"
                  sx={{
                    backgroundColor: "#3560AD",
                    "&:hover": { backgroundColor: "#4682B4" },
                    marginLeft: "7px",
                  }}
                  color="text"
                  onClick={ExportExcelWithDates}
                >
                  {translations.SearchEnteryExportSearchtoExcelWithDates}
                </MDButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchEntries;
